import { useMutation } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";

const useExportDocuments = () => {
  const mutation = useMutation(({ companyId, documentTypeIds }) => {
    return axiosClient.post(
      `/DocumentType/ExportDocuments?companyId=${companyId}`,
      documentTypeIds
    );
  });
  return mutation;
};
export default useExportDocuments;
